// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"k6DDX","left":"_355DQ","right":"fvTRC","center":"scLbW","logo":"RGAU1","title":"_1rr64"};